<template>
  <page :loading="loading">
    <template #content>
    <div class="mt-n10">
    <div v-if="isTotpConfigured">
      <p>QR code verification is enabled</p>
      <v-btn color="primary" @click="showQrCode">Show existing QR code</v-btn>
      <v-btn text @click="deleteQrCode">Delete</v-btn>
      <qrcode-vue
        :value="totpUrl"
        size="300"
        level="H"
        v-if="showIsCLicked"
        class="pt-5"></qrcode-vue>
    </div>
   <v-form ref="form" v-model="valid" style="max-width: 600px" v-if="!isTotpConfigured">
      <v-col cols="12">
        <p>{{setupText}}</p>
        <v-btn style="width:300px" color="primary" class="mb-2" @click="set2Fa">Setup</v-btn>
      </v-col>
      <v-col cols="12">
        <qrcode-vue :value="totpUrl" size="300" level="H" v-if="setupClicked"></qrcode-vue>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-if="setupClicked"
          outlined
          dense
          label="Verification Code"
          @keydown="restrictNumeric"
          :rules="[global.rules.requiredField]"
          style="width: 300px"
          v-model="totpcode"
          ref="totpcode"/>
      </v-col>
    </v-form>
  </div>
    </template>
  </page>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
const Iam = require('iam')
import SettingsStrings from "./SettingsStrings"

export default {
  components: {QrcodeVue},
  data() {
    return {
      valid: true,
      loading: true,
      totpUrl: "",
      totpcode: "",
      totpsecret: "",
      setupClicked: false,
      totpissuer: "",
      showIsCLicked: false,
      isTotpConfigured: true,
      setupText: SettingsStrings(this, "setup_text")
    }
  },
  created: function () {
    this.isConfigured()
  },
  computed: {
    isConfigured () {
      return this.$api.getTwoFAMethods(this.username, this.callBack(
        response => {
          return this.isTotpConfigured = response.totp
        }, undefined, ()=> {
          this.loading = false
        }
      ))
    }
  },
  watch: {
    totpcode: function () {
      if (this.totpcode.length == 6) {
        let verify = new Iam.TOTPSecret()
        verify.totpsecret = this.totpsecret
        verify.totpcode = this.totpcode
        this.$api.setupTOTP(verify ,this.username, this.callBack(
          ()=> {
            this.alert("info", SettingsStrings(this, "setup_successfully"), undefined, undefined,() => {
              this.isTotpConfigured = !this.isTotpConfigured
            })
          }
        ))
      }
    }
  },
  methods:{
    set2Fa () {
      this.setupClicked = true
      this.$api.getTOTPSecret(this.username, this.callBack(
        (response)=> {
          this.totpsecret = response.totpsecret
          console.log(response.totpissuer)
          this.totpUrl = `otpauth://totp/iam:${this.username}?secret=${response.totpsecret}&issuer=${response.totpissuer}`
        }
      ))
      this.alert("info", SettingsStrings(this, "setup_onclick"),  undefined, undefined, ()=> {
        this.$refs.totpcode.focus()
      })
    },
    showQrCode () {
      this.showIsCLicked = true
      this.$api.getTOTPSecret(this.username, this.callBack(
        (response)=> {
          this.totpsecret = response.totpsecret
          this.totpUrl = `otpauth://totp/iam:${this.username}?secret=${this.totpsecret}&issuer=iam`
        }
      ))
    },
    deleteQrCode () {
      this.alert("confirm", SettingsStrings(this, "confirm_delete"), undefined,() => {
        this.$api.removeTOTP(this.username, this.callBack( ()=>{
          this.isTotpConfigured = !this.isTotpConfigured
        } ))
      })
    }
  },
}
</script>